import { getManufacturer, getManufacturers } from "api/manufacturers/calls";
import { createPrimitivePaginatedHook, createPrimitiveHook } from "hooks/createPrimitiveHook";

export const useManufacturer = createPrimitiveHook(getManufacturer);
export const useManufacturers = createPrimitivePaginatedHook(getManufacturers);
